import { render, staticRenderFns } from "./AddSellElctric.vue?vue&type=template&id=1ed422d0&scoped=true"
import script from "./AddSellElctric.vue?vue&type=script&lang=js"
export * from "./AddSellElctric.vue?vue&type=script&lang=js"
import style0 from "./AddSellElctric.vue?vue&type=style&index=0&id=1ed422d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed422d0",
  null
  
)

export default component.exports